import Vue from 'vue';
import Vuex from 'vuex';
import user from './modules/user';
import breadcrumb from './modules/breadcrumb';
import tagsNav from './modules/tags_nav';
import base from './modules/base';

Vue.use(Vuex);

const store = new Vuex.Store({
  state: {
    ...user.state,
    ...breadcrumb.state,
    ...tagsNav.state,
    ...base.state
  },
  getters: {
    ...user.getters,
    ...breadcrumb.getters,
    ...tagsNav.getters,
    ...base.getters,
  },
  mutations: {
    ...user.mutations,
    ...breadcrumb.mutations,
    ...tagsNav.mutations,
    ...base.mutations
  },
  actions: {
    ...user.actions,
    ...breadcrumb.actions,
    ...tagsNav.actions,
  },
});

// 热重载
if (module.hot) {
  // 指定要监控的文件
  module.hot.accept([store.mutations], () => {
    store.hotUpdate({
      mutations: store.mutations,
    });
  });
}

export default store;
